// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAmTgHiCjwiulLMFAd_f0H_z2VJNdaIzK8",
  authDomain: "thetechbus-e7780.firebaseapp.com",
  projectId: "thetechbus-e7780",
  storageBucket: "thetechbus-e7780.firebasestorage.app",
  messagingSenderId: "366875218934",
  appId: "1:366875218934:web:d40c3b7766a2db852d6dd7",
  measurementId: "G-R50YT81VZD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Auth
const auth = getAuth(app);

// Initialize Storage
const storage = getStorage(app);

export { db, auth, storage };